import { Component, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-row-header',
    templateUrl: './row-header.component.html',
    styleUrls: ['./row-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class RowHeaderComponent {
    @Output() toggleMenu = new EventEmitter<true>();

    expanded = false;

    onToggleMenu() {
        this.toggleMenu.emit(true);
        this.expanded = !this.expanded;
    }
}
